
function initProductPageSlider() {
  $('[data-product-main-slider]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    asNavFor: '.product-image-slider__thumb-slider',
  });

  const thumbSlider = $('[data-product-thumb-slider]').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    asNavFor: '.product-image-slider__main-slider'
  });


  // $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
  //   console.log(currentSlide, nextSlide)
  //   const total = slick.slideCount;
  //   const percent = (nextSlide + 1) / total * 100;
  //   progressLine.style.width = `${percent}%`;
  // });
}

document.addEventListener('DOMContentLoaded', initProductPageSlider);
